import ExpandMore from '@mui/icons-material/ExpandMore'
import CheckCircle from '@mui/icons-material/CheckCircle'
import RadioButtonUnchecked from '@mui/icons-material/RadioButtonUnchecked'
import { Accordion, AccordionDetails, AccordionSummary, Box, Chip, Typography } from '@mui/material'
import QuestionComponent from './QuestionComponent'
import styled from 'styled-components'

const StyledAccordion = styled(Accordion)`
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08), 0 1px 4px rgba(0, 0, 0, 0.04) !important;
  border: 1px solid rgba(103, 121, 227, 0.1) !important;
  margin-bottom: 0 !important;
  overflow: hidden;
  transition: all 0.3s ease;

  &:before {
    display: none;
  }

  &:hover {
    box-shadow: 0 4px 16px rgba(103, 121, 227, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06) !important;
  }

  &.Mui-expanded {
    margin: 0 0 16px 0 !important;
  }
`

const StyledAccordionSummary = styled(AccordionSummary)`
  background: rgba(103, 121, 227, 0.04);
  padding: 16px 20px !important;
  min-height: 64px !important;
  border-bottom: 1px solid rgba(103, 121, 227, 0.1);

  &.Mui-expanded {
    border-bottom: 1px solid rgba(103, 121, 227, 0.2);
  }

  .MuiAccordionSummary-content {
    margin: 0 !important;
    align-items: center;
    gap: 12px;
  }

  .MuiAccordionSummary-expandIconWrapper {
    color: #6779e3;
  }
`

const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 24px !important;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const SectionTitle = styled(Typography)`
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.02em;
  flex: 1;
`

const ProgressChip = styled(Chip)`
  height: 28px;
  font-size: 12px;
  font-weight: 600;
  background: ${(props) => (props.$completed ? 'rgba(16, 185, 129, 0.1)' : 'rgba(148, 163, 184, 0.1)')};
  color: ${(props) => (props.$completed ? '#059669' : '#64748b')};
  border: 1px solid ${(props) => (props.$completed ? 'rgba(16, 185, 129, 0.3)' : 'rgba(148, 163, 184, 0.3)')};
`

export default function SectionComponent({ sectionObject, getQuestionAnswer, handleChangeAnswer, selectedLanguage }) {
  function getAnsweredQuestionsCount() {
    let count = 0
    sectionObject?.questions?.forEach((question) => {
      if (getQuestionAnswer(question?.id)) {
        count++
      }
    })
    return count
  }

  const totalQuestions = sectionObject?.questions?.length || 0
  const answeredCount = getAnsweredQuestionsCount()
  const isCompleted = answeredCount === totalQuestions && totalQuestions > 0

  return (
    <StyledAccordion defaultExpanded={false}>
      <StyledAccordionSummary expandIcon={<ExpandMore />}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
          {isCompleted ? (
            <CheckCircle sx={{ color: '#10b981', fontSize: 24 }} />
          ) : (
            <RadioButtonUnchecked sx={{ color: '#94a3b8', fontSize: 24 }} />
          )}
          <SectionTitle>{sectionObject?.title}</SectionTitle>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <ProgressChip
              $completed={isCompleted}
              label={`${answeredCount}/${totalQuestions} answered`}
              size="small"
            />
          </Box>
        </Box>
      </StyledAccordionSummary>
      <StyledAccordionDetails>
        {sectionObject?.questions?.map((question) => (
          <QuestionComponent
            key={question?.id}
            question={question}
            getQuestionAnswer={getQuestionAnswer}
            handleChangeAnswer={(questionId, value) =>
              handleChangeAnswer(questionId, sectionObject?.id, value, question, sectionObject)
            }
            selectedLanguage={selectedLanguage}
          />
        ))}
      </StyledAccordionDetails>
    </StyledAccordion>
  )
}
